import Urls from "../../constants/urls";
import Frame1 from "./imgs/frame1.jpg";
import Frame2 from "./imgs/frame2.jpg";

export const homeUrl = Urls.auto2.frame1.path;

export const rooms = [
    {
        name: "Frame 1",
        img: Frame1,
        route: Urls.auto2.frame1,
        yRotation: 360,
    },
    {
        name: "Frame 2",
        img: Frame2,
        route: Urls.auto2.frame2,
        yRotation: 360,
    },
];
